import { getRealTimeDataAPI } from "../apis/getRealTimeDataAPI";
import { formatToLocalTime } from "../helpers/datetimeHandlers";
import {
  timestampCherryPick,
  timestampCherryPickInOneHour
} from "./timestampCherryPick";
import dayjs from "dayjs";

export const getRealTimeData = async (
  device_id,
  type,
  take,
  mins,
  dateInHour,
  numOfPartition = 60
) => {
  let realTimeData = await getRealTimeDataAPI(device_id, type, mins, 1);
  if (
    realTimeData.dataSets &&
    (type === "network_wifi" ||
      type === "network_cellular" ||
      type === "network_ethernet")
  ) {
    const newData = realTimeData.dataSets[realTimeData.dataSets.length - 1];
    const d = [];
    newData.data.forEach((v, ind) => {
      d.push({
        name: newData.label,
        value: newData.data[ind],
        unit: "dbm",
        created_at: realTimeData.label[ind]
      });
    });
    realTimeData = d;
  }
  realTimeData = fillLackingTimePoints(mins, realTimeData);
  // let pickedTimeData = timestampCherryPick(numOfPartition, realTimeData);
  let pickedTimeData = timestampCherryPickInOneHour(dateInHour, realTimeData);
  let valueArr = [];
  if (realTimeData) {
    if (type === "connection") {
      valueArr = getAverageOnlineStatus(pickedTimeData, numOfPartition);
    } else {
      valueArr = pickedTimeData.map(item => item.value);
    }
  }
  if (realTimeData) {
    const labelArr = pickedTimeData.map(item => {
      const time = formatToLocalTime(item.created_at);
      return time; // this is to break the date and time in seperate line
    });

    const date = pickedTimeData.map(item => {
      const date = formatToLocalTime(item.created_at); // utc to local time zone
      return date; // this is to break the date and time in seperate line
    });

    const unit = pickedTimeData.map(item => {
      return item.unit || "%"; // this is to break the date and time in seperate line
    });

    const data = {
      valueArr: valueArr.reverse(),
      labelArr: labelArr.reverse(),
      date: date,
      unit: unit
    };
    return data;
  }
  return {
    valueArr: [],
    labelArr: [],
    date: [],
    unit: []
  };
};

const fillLackingTimePoints = (mins, realTimeData) => {
  let filledTimePoints = [];

  let current = dayjs().utc();
  let oneMinute = dayjs.duration(1, "minutes");
  current = current.subtract(oneMinute);
  const timeArray = realTimeData.map(item => item.created_at);
  const timeSet = new Set(timeArray);

  for (let i = 0; i < mins; i++) {
    const formattedCurrent = current.format("YYYY-MM-DD HH:mm");

    if (!timeSet.has(formattedCurrent)) {
      filledTimePoints.push({
        created_at: formattedCurrent,
        value: "0",
        unit: null
      });
    } else {
      const data = realTimeData.find(
        item => item.created_at === formattedCurrent
      );
      filledTimePoints.push(data);
    }
    current = current.subtract(oneMinute);
  }

  return filledTimePoints;
};

const getAverageOnlineStatus = (data, numOfPartition) => {
  const size = data.length;
  const timeInterval = size / numOfPartition;
  let avgTimeStatus = [];
  let avg = 0;

  for (let i = 0; i < size; i += timeInterval) {
    let total = 0;
    for (let j = 0; j < timeInterval; j++) {
      total += parseInt(data[i + j].value);
    }
    avg = total / timeInterval;

    if (avg >= 0.5) {
      avgTimeStatus.push("Online");
    } else {
      avgTimeStatus.push("Offline");
    }
  }

  return avgTimeStatus;
};
